<script>
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";

  export let url;
  $: isExternal = isExternalUrl(url, $page.url?.origin);

  let clazz = "";
  /** @type { string } */
  export { clazz as class };

  /**
   * simplest way to make the entire card clickable
   * may need refactoring if we end up supporting more complex cards
   *
   */
  function handleClick() {
    if (isExternal) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  }

  let hasFocus = false;
  function createFocusHandler(bool) {
    return () => {
      hasFocus = bool;
    };
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="underline-offset-2 tracking-wide decoration-1 leading-6 text-left hover:cursor-pointer {clazz}"
  aria-label="Card"
  on:click={handleClick}
  on:focusin={createFocusHandler(true)}
  on:focusout={createFocusHandler(false)}
>
  <slot {hasFocus} />
</div>
